import type { PostProcessorsRootMap } from '../../shared/post-processors';
import type { DateTimeFormat, DateTimeSettings } from './types';

const dateTimePostProcessors: PostProcessorsRootMap<DateTimeFormat, DateTimeSettings> = {
    ru: {
        dateLong: (v: string) => v.replace(' г.', ''),
        dateWeekDay: (v: string) => v.replace(' г.', '').split(', ').reverse().join(', '),
        dateWeekDayShort: (v: string) => v.replace(' г.', '').split(', ').reverse().join(', '),
        monthYear: (v: string) => v.replace(' г.', ''),
        dateTime: (v: string) => v.replace(',', ''),
        dateTimeShort: (v: string) => v.replace(',', ''),
    },
};


export {
    dateTimePostProcessors,
}
